import { put, takeLatest } from "redux-saga/effects";
import { types } from "../action_types";
import { GET, POST, PUT, DELETE } from "../../Utils/httpServices";
import CustomToster from "../../SharedComponents/CustomToaster";

const multipartHeaders = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

function* GetBlockchainsSaga({ payload }) {
  const { page, limit } = payload;
  try {
    const blockchainsAllData_response = yield GET(
      `admin/blockchains/all?page=${page}&limit=${limit || 100}&name=${
        payload?.searchText || ""
      }`
    );

    const { docs, currentPage, itemsPerPage, totalDocs, totalPages } =
      blockchainsAllData_response?.data.data.result;

    const blockchains = docs;
    const pagination = {
      currentPage,
      itemsPerPage,
      totalDocs,
      totalPages,
    };

    if (blockchainsAllData_response?.status === 200) {
      yield put({
        type: types.GetBlockchainsRequestSuccess,
        payload: { blockchains, pagination },
      });
    } else {
      yield put({ type: types.GetBlockchainsRequestFailure });
    }
  } catch (e) {
    CustomToster({
      type: "error",
      message: e?.response?.data?.message || e?.response?.data?.error?.message || e?.message,
    });
    yield put({ type: types.GetBlockchainsRequestFailure });
  }
}

function* CreateBlockchainsSaga({ payload }) {
  let { formData, handleCloseModal, page } = payload;

  try {
    const createdBlockchainsData_response = yield POST(
      "admin/blockchains/add",
      formData,
      { ...multipartHeaders }
    );

    if (createdBlockchainsData_response?.status === 200) {
      yield put({
        type: types.CreateBlockchainsRequestSuccess,
      });
      yield put({
        type: types.GetBlockchainsRequest,
        payload: { page },
      });
      CustomToster({
        type: "success",
        message: "Blockchain Created Successfully",
      });
    } else {
      yield put({ type: types.CreateBlockchainsRequestSuccess });
    }
    handleCloseModal();
  } catch (e) {
    CustomToster({
      type: "error",
      message: e?.response?.data?.message || e?.response?.data?.error?.message || e?.message,
    });
    yield put({ type: types.CreateBlockchainsRequestFailure });
  }
}

function* EditBlockchainsSaga({ payload }) {
  let { updatedBody, handleCloseModal, page } = payload;

  try {
    const editBlockchainsData_response = yield PUT(
      "admin/blockchains/edit",
      updatedBody
    );

    if (editBlockchainsData_response?.status === 200) {
      yield put({
        type: types.EditBlockchainsRequestSuccess,
      });

      yield put({
        type: types.GetBlockchainsRequest,
        payload: { page },
      });

      CustomToster({
        type: "success",
        message: "Blockchain Edited Successfully",
      });
    } else {
      yield put({ type: types.EditBlockchainsRequestFailure });
    }
    handleCloseModal();
  } catch (e) {
    CustomToster({
      type: "error",
      message: e?.response?.data?.message || e?.response?.data?.error?.message || e?.message,
    });
    yield put({ type: types.EditBlockchainsRequestFailure });
  }
}

function* DeleteBlockchainsSaga({ payload }) {
  const { blockchainId, page } = payload;

  try {
    // Using path parameter for consistency with other DELETE endpoints (admin/task/:id, admin/quest/:id)
    const deleteBlockchainsData_response = yield DELETE(
      `admin/blockchains/delete/${blockchainId}`
    );

    if (deleteBlockchainsData_response?.status === 200) {
      yield put({
        type: types.DeleteBlockchainsRequestSuccess,
      });

      yield put({
        type: types.GetBlockchainsRequest,
        payload: { page },
      });

      CustomToster({
        type: "success",
        message: "Blockchain Deleted Successfully",
      });
    } else {
      yield put({ type: types.DeleteBlockchainsRequestFailure });
    }
  } catch (e) {
    CustomToster({
      type: "error",
      message: e?.response?.data?.message || e?.response?.data?.error?.message || e?.message,
    });
    yield put({ type: types.DeleteBlockchainsRequestFailure });
  }
}

export default function* BlockchainsSaga() {
  yield takeLatest(types.GetBlockchainsRequest, GetBlockchainsSaga);
  yield takeLatest(types.CreateBlockchainsRequest, CreateBlockchainsSaga);
  yield takeLatest(types.EditBlockchainsRequest, EditBlockchainsSaga);
  yield takeLatest(types.DeleteBlockchainsRequest, DeleteBlockchainsSaga);
}
